
import React from 'react';
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";

interface EmptyTimelineProps {
  activeFilter: string;
  onAddInteraction: () => void;
}

export const EmptyTimeline: React.FC<EmptyTimelineProps> = ({ 
  activeFilter, 
  onAddInteraction 
}) => (
  <div className="text-center py-8 text-muted-foreground">
    <MessageSquare className="h-12 w-12 mx-auto mb-2 opacity-50" />
    <p>No {activeFilter === 'all' ? '' : activeFilter} interactions found</p>
    <Button 
      variant="outline" 
      size="sm" 
      className="mt-2"
      onClick={onAddInteraction}
    >
      Add First Interaction
    </Button>
  </div>
);
